import * as React from "react";
const SvgHidden1 = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M16.95 17.367A8.392 8.392 0 0 1 12 19.083c-5.833 0-9.167-6.666-9.167-6.666a15.375 15.375 0 0 1 4.217-4.95m3.2-1.517a7.6 7.6 0 0 1 1.75-.2c5.833 0 9.167 6.667 9.167 6.667a15.412 15.412 0 0 1-1.8 2.658m-5.6-.892a2.498 2.498 0 0 1-4.147-.768 2.5 2.5 0 0 1 .613-2.765M5 4.417l14.667 15.166"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgHidden1;
